const actions = {
  GET_FLIGHT_LIST: "GET_FLIGHT_LIST",
  GET_FLIGHT_LIST_SUCCESS: "GET_FLIGHT_LIST_SUCCESS",
  GET_FLIGHT_LIST_ERROR: "GET_FLIGHT_LIST_ERROR",
  RESET_FLIGHT_LIST: "RESET_FLIGHT_LIST",

  SET_ALERT_DETAILS: "SET_ALERT_DETAILS",
  SET_ACTIVITY_DETAILS: "SET_ACTIVITY_DETAILS",
  SET_ACTIVITY_LOADING_TRUE: "SET_ACTIVITY_LOADING_TRUE",
  SET_ACTIVITY_LOADING_FALSE: "SET_ACTIVITY_LOADING_FALSE",
  SET_ALERT_LOADING_TRUE: "SET_ALERT_LOADING_TRUE",
  SET_ALERT_LOADING_FALSE: "SET_ALERT_LOADING_FALSE",
  SET_GOOGLE_USER: "SET_GOOGLE_USER",
  GET_GOOGLE_USER: "GET_GOOGLE_USER",
  SET_USER_CREDITS: "SET_USER_CREDITS",
  SET_USER_FIRSTNAME: "SET_USER_FIRSTNAME",
  SET_USER_LASTNAME:  "SET_USER_LASTNAME",
  SET_USER_OBJECT: "SET_USER_OBJECT",
  REMOVE_LOADING_CIRCLE: "REMOVE_LOADING_CIRCLE",
  SET_USER_ALERTS: "SET_USER_ALERTS",
  SET_WINDOW_HEIGHT : "SET_WINDOW_HEIGHT",
  SET_WINDOW_HEIGHT_FIXED : "SET_WINDOW_HEIGHT_FIXED",
  SET_ABOUT_HIDE : "SET_ABOUT_HIDE",
  SET_ABOUT_SHOW : "SET_ABOUT_SHOW",
  SET_ROUTE_OPTION : "SET_ROUTE_OPTION",
  SET_USER_ALERTS_BY_REG :"SET_USER_ALERTS_BY_REG",
  SET_USER_LOADING : "SET_USER_LOADING",
  SET_USER_LOADING_OFF :"SET_USER_LOADING_OFF",
  SET_USER_ALERTS_LAST_SEARCH: "SET_USER_ALERTS_LAST_SEARCH",
  SET_ACCOUNT_INFO: "SET_ACCOUNT_INFO",
  SET_ACCOUNT_LOADING: "SET_ACCOUNT_LOADING",
  SET_ACCOUNT_LOADING_OFF: "SET_ACCOUNT_LOADING_OFF"


};

export default actions;
